import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsApi } from '../../../infrastructure/api/investigations.api';
import type { SubmitInvestigationForApprovalCommand } from './submit-investigation-for-approval.command';
import type { SubmitInvestigationForApprovalResult } from './submit-investigation-for-approval.result';

@Injectable({ providedIn: 'root' })
export class SubmitInvestigationForApprovalUseCase {
  private readonly _api = inject(InvestigationsApi);
  private readonly _toast = inject(ToastProvider);

  public execute(command: SubmitInvestigationForApprovalCommand): Observable<SubmitInvestigationForApprovalResult> {
    return this._api.submitForApproval(command.investigationId).pipe(
      tap(() => {
        this._toast.success(
          'Submitted for approval',
          'The investigation has been submitted for approval.',
        );
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._toast.error(
          'Failed to submit for approval',
          'Please try again or contact support if the issue persists.',
        );
        return throwError(() => error);
      }),
    );
  }
}
